import ConfiguracoesPage from "@/Pages/Administracao/ConfiguracoesPage.vue";
import ConfiguracoesModulosPage from "@/Pages/Administracao/ConfiguracoesModulosPage.vue";
import AparelhosFaciaisPage from "@/Pages/Administracao/AparelhosFaciaisPage.vue";
import MinhasNotificacoesPage from "@/Pages/Administracao/MinhasNotificacoesPage.vue";
import DatasComemorativasPage from "@/Pages/Administracao/DatasComemorativasPage.vue";
import store from "@/store";
import authService from "@/Services/AuthService";

const ROLES_ADMIN = ["admin", "super-admin", "TI"];
const ROLES_APARELHOS = ["admin", "super-admin"];
const ROLES_NOTIFICACOES = ["admin", "super-admin", "TI", "lider"];
// Central de configurações: cada cartão aparece conforme o perfil (ver ConfiguracoesPage).
// O colaborador entra para ajustar as próprias preferências (ex.: datas comemorativas).
const ROLES_CONFIGURACOES = ["admin", "super-admin", "TI", "lider", "colaborador"];

function exigirPerfis(roles) {
  return async (to, from, next) => {
    let user = store.getters["Auth/user"];
    if (!user && authService.isLoggedIn()) {
      try {
        await authService.syncUserWithStore();
      } catch (e) {
        // ignore
      }
      user = store.getters["Auth/user"];
    }
    if (!roles.includes(user?.roleName)) {
      return next({ name: "NaoAutorizado" });
    }
    return next();
  };
}

export default [
  {
    path: "/administracao/configuracoes",
    name: "administracao.configuracoes",
    component: ConfiguracoesPage,
    beforeEnter: exigirPerfis(ROLES_CONFIGURACOES),
  },
  {
    path: "/administracao/configuracoes/modulos",
    name: "administracao.configuracoes.modulos",
    component: ConfiguracoesModulosPage,
    beforeEnter: exigirPerfis(ROLES_ADMIN),
  },
  {
    path: "/administracao/configuracoes/aparelhos",
    name: "administracao.aparelhos",
    component: AparelhosFaciaisPage,
    beforeEnter: exigirPerfis(ROLES_APARELHOS),
  },
  {
    path: "/administracao/configuracoes/datas-comemorativas",
    name: "configuracoes.datasComemorativas",
    component: DatasComemorativasPage,
    beforeEnter: exigirPerfis(ROLES_CONFIGURACOES),
  },
  {
    path: "/administracao/configuracoes/notificacoes",
    name: "administracao.minhasNotificacoes",
    component: MinhasNotificacoesPage,
    beforeEnter: exigirPerfis(ROLES_NOTIFICACOES),
  },
  // Endereços antigos (antes da central de configurações)
  { path: "/administracao/aparelhos", redirect: { name: "administracao.aparelhos" } },
  {
    path: "/administracao/minhas-notificacoes",
    redirect: { name: "administracao.minhasNotificacoes" },
  },
];
